import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import { authSelectors } from '../../../../../redux/app/auth';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    children: React.ReactNode;
	vesselId: string;
};
type CRBCoverPageProps = PropsFromRedux & OwnProps;
function CRBCoverPage(props: CRBCoverPageProps) {
    const {
        dateRange,
        vesselName,
        imoNumber,
        distinctiveNumberOrLetters,
        children,
    } = props;

    return (
        <div>
            {/* First Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2">
                <div className="mx-0 my-24 text-xl font-medium text-center">
                    <h3 className="uppercase">Cargo Record Book</h3>
                    <span className="italic">
                        For Ships Carrying Noxious Liquid Substance
                    </span>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">Name of ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {vesselName}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">
                                Distinctive number or letters:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
                                {distinctiveNumberOrLetters}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">IMO Number:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {imoNumber}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">
                                Gross tonnage:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
                                {props?.tonnage?.grossTonnage || ''}
                            </p>
                        </div>
                        <div
                            className="flex items-center justify-between mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period from :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {dateRange?.startDate &&
                                        moment(dateRange?.startDate).format(
                                            'DD-MM-yyyy'
                                        )}{' '}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">to :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {dateRange?.endDate &&
                                        moment(dateRange?.endDate).format(
                                            'DD-MM-yyyy'
                                        )}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Plan View */}
            <div className="flex flex-col justify-between px-8 py-4 pt-0 mb-2 text-left newpage">
                <div className="mb-4 text-center">
                    <h2 className="text-xl uppercase">
                        Plan view of cargo and slop tanks
                    </h2>
                    <p className="text-lg">(to be completed on board)</p>
                </div>
                <div className="flex flex-col my-8">
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mb-0 mr-2 text-base min-w-fit">
                            Name of ship
                        </p>
                        <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                            {vesselName}
                        </p>
                    </div>
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mb-0 mr-2 text-base min-w-fit">
                            Distinctive number or letters
                        </p>
                        <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                            {distinctiveNumberOrLetters}
                        </p>
                    </div>
                </div>
                <div>{children}</div>
            </div>
            {/* Second Page */}
            <div className="flex flex-col justify-between px-8 py-4 pt-0 mb-2 text-left newpage">
                <section className="mb-8 border-2 border-gray-300 p-4 bg-gray-100">
                    <h2 className="text-xl text-center font-bold mb-4">
                        NOTICE
                    </h2>
                    <p className="mb-4">
                        This is the official Cargo Record Book for the Maritime
                        Administration, complete with enclosed instructions. The
                        book is designed so that it may be used by all ships
                        carrying noxious liquid substances (NLS) in bulk, or any
                        mixture containing such substances for making entries
                        regarding cargo and ballast operations.
                    </p>
                    <p>
                        The book shall be completed on a tank by tank basis
                        whenever a ship loads internally transfers, or unloads
                        NLS in bulk or any mixture containing such substance;
                        whenever a ship cleans or ballasts the NLS Cargo tanks;
                        whenever a ship discharges ballast from the NLS Cargo
                        Tanks or disposes of NLS residue or any mixture
                        containing such substance to a reception facility;
                        whenever a ship discharges an NLS or any mixture
                        containing such substance, whether intentional or
                        accidental into the water; and whenever a ship removes
                        by ventilation NLS residues.
                    </p>
                </section>
            </div>
            {/* Third Page */}
            <div className="px-8 py-0 newpage">
                <section className="mb-8">
                    <h2 className="text-xl text-center font-bold mb-4">
                        CARGO RECORD BOOK INSTRUCTIONS
                    </h2>
                    <h3 className="text-lg text-center font-bold mb-2">
                        GENERAL INSTRUCTIONS
                    </h3>
                    <ol className="list-decimal pl-6 space-y-2">
                        <li>
                            A Cargo Record Book shall be maintained on every
                            vessel Carrying Noxious Liquid Substances in bulk,
                            in accordance with the provisions of MARPOL 73/78,
                            Annex II.
                        </li>
                        <li>
                            The Cargo Record Book must be available at all times
                            for examination by Nautical Inspectors or Inspectors
                            of any Port State when within the jurisdiction of
                            that State. The Cargo Record Book must be preserved
                            for three years from the date of the last entry.
                        </li>
                        <li>
                            The Cargo Record Book must be properly completed.
                            All Noxious Liquid Substance cargo and ballast
                            operations must be clearly and accurately recorded.
                        </li>
                        <li>
                            Owners and their Legal Advisors, Masters and
                            Officers are reminded that, in addition to statutory
                            requirements concerning maintenance of an Cargo
                            Record Book, this record is a valuable means of
                            providing proof that the ship has complied with
                            anti-pollution regulations.
                        </li>
                        <li>
                            Pages (ii) thru (iv) of this instruction booklet
                            show a comprehensive list of items of Noxious Liquid
                            Substance Cargo and Ballast operations which are,
                            when appropriate, to be recorded in the Cargo Record
                            Book in accordance with Regulation 15 of Annex II of
                            the International Convention for the Prevention of
                            Pollution from Ships, 1973, as modified by the
                            protocol of 1978 relating thereto (MARPOL 73/78), as
                            amended. The items have been grouped into
                            operational sections, each of which is denoted by a
                            letter code.
                        </li>
                        <li>
                            When making entries in the Cargo Record Book, the
                            date, operational letter code and item number shall
                            be inserted in the appropriate columns and the
                            required particulars shall be recorded
                            chronologically in the blank spaces. The Cargo
                            Record Book Shall be maintained in the English
                            language.
                        </li>
                        <li>
                            When a surveyor appointed or authorized by the
                            Administration to supervise any operations under
                            this Annex has inspected the vessel, that surveyor
                            shall make an appropriate entry in the Cargo Record
                            book.
                        </li>
                        <li>
                            Each completed operation shall be signed for and
                            dated by the officer or officers in charge and, if
                            applicable, by the surveyor authorized by the
                            competent authority of the State in which the ship
                            is unloading. Each completed page shall
                            countersigned by the Master of the ship.
                        </li>
                    </ol>
                </section>
            </div>
            {/* Fourth Page */}
            <div className="px-8 py-0 mt-4 newpage">
                <section className="mb-8">
                    <h2 className="text-xl text-center font-bold mb-4">
                        MARPOL 73/78 Annex II Regulation 15
                    </h2>
                    <h3 className="text-lg text-center font-bold mb-2">
                        CARGO RECORD BOOK
                    </h3>
                    <ol className="list-decimal pl-6 space-y-2">
                        <li>
                            Every ship to which this annex applies shall be
                            provided with a Cargo Record Book, whether as part
                            of the ship's official logbook or otherwise, in the
                            form specified in appendix 2 to this Annex.
                        </li>
                        <li>
                            After completion of any operation specified in
                            appendix 2 to this Annex, the operation shall be
                            promptly recorded in the Cargo Record Book.
                        </li>
                        <li>
                            In the event of an accidental discharge of a Noxious
                            Liquid Substance or a mixture containing such a
                            substance or a discharge under the provisions of
                            regulation 3 of this Annex, an entry shall be made
                            in the Cargo Record Book stating the circumstances
                            of, and reasons for, the discharge.
                        </li>
                        <li>
                            Each entry shall be signed by the officer or
                            officers in charge of the operation concerned and
                            each page shall be signed by the master of the ship.
                            The entries in the Cargo Record Book, for ships
                            holding an International Pollution Prevention
                            Certificate for the Carriage of Noxious Liquid
                            Substances in Bulk or a Certificate referred to in
                            regulation 7 of this Annex shall be at least in
                            English, French or Spanish. Where entries in a
                            official national language of the State whose flag
                            the ship is entitled to fly are also used, this
                            shall prevail in case of dispute or discrepancy.
                        </li>
                        <li>
                            The Cargo Record Book shall be kept in such a place
                            as to be readily available for inspection, and
                            except in the case of unmanned ships under tow,
                            shall be kept on board the ship. It shall be
                            retained for a period of three years after the last
                            entry has been made.
                        </li>
                        <li>
                            The competent authority of the Government of a Party
                            may inspect the Cargo Record book on board any ship
                            to which this Annex applies while the ship is in
                            port, and may make a copy of any entry in that book
                            and may require the master to certify that the copy
                            is a true copy of such entry. Any copy so made which
                            has been certified by the master of the ship as a
                            true copy of an entry in the ship's Cargo Record
                            book shall be made admissible in any judicial
                            proceedings as evidence of the facts stated in the
                            entry. The inspection of a Cargo Record Book and the
                            taking of a certified copy by the competent
                            authority under this paragraph shall be performed as
                            expeditiously as possible without causing the ship
                            to be unduly delayed.
                        </li>
                    </ol>
                </section>
            </div>
            {/* Fifth page */}
            <div className="px-8 py-4 mt-4 newpage">
                <section className="mb-8">
                    <h2 className="text-xl text-center font-bold mb-4">
                        INTRODUCTION
                    </h2>
                    <p className="mb-4">
                        The following pages show a comprehensive list of items
                        of cargo and ballast operations which are, when
                        appropriate, to be recorded in the Cargo Record Book on
                        a tank to tank basis in accordance with regulation 15.2
                        of Annex II of the International Convention for the
                        Prevention of Pollution from Ships, 1973, as modified by
                        the Protocol of 1978 relating thereto (MARPOL 73/78), as
                        amended. The items have been grouped into operational
                        sections, each of which is denoted by a letter.
                    </p>
                    <p className="mb-4">
                        When making entries in the Cargo Record Book, the date,
                        operational code and item number shall be inserted in
                        the appropriate columns and the required particulars
                        shall be recorded chronologically in the blank spaces.
                    </p>
                    <p>
                        Each completed operation shall be signed for and dated
                        by the officer or officers in charge and, if applicable,
                        by a surveyor authorized by the competent authority of
                        the State in which the ship is unloading. Each completed
                        page shall be countersigned by the master of the ship.
                    </p>
                </section>
            </div>
            {/* Sixth Page */}
            <div className="px-8 py-4 newpage">
                <section className="mb-8">
                    <h2 className="text-xl text-center font-bold mb-4">
                        LIST OF ITEMS TO BE RECORDED
                    </h2>
                    <h3 className="text-center font-bold mb-2">
                        Entries required for operations involving all categories
                        of substances.
                    </h3>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (A) LOADING OF CARGO
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Place of loading</li>
                            <li>
                                Identify tank(s), name of substance(s) and
                                category(ies).
                            </li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (B) INTERNAL TRANSFER OF CARGO
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Name of category of cargo(es) transferred.</li>
                            <li>
                                Identity of tanks:
                                <ol className="list-decimal pl-6">
                                    <li>from:</li>
                                    <li>to:</li>
                                </ol>
                            </li>
                            <li>Was (were) the tank(s) in 4.1 emptied?</li>
                            <li>If not, quantity remaining in tank(s).</li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (C) UNLOADING OF CARGO
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Place of unloading.</li>
                            <li>Identity of tank(s) unloaded.</li>
                            <li>
                                Was (were) the tank(s) emptied?
                                <ol className="list-decimal pl-6">
                                    <li>
                                        If yes, confirm that the procedure for
                                        emptying and stripping has been
                                        performed in accordance with the ship's
                                        Procedures and Arrangements Manual
                                        (i.e., list, trim, stripping
                                        temperature.)
                                    </li>
                                    <li>
                                        If not, quantity remaining in tank(s).
                                    </li>
                                </ol>
                            </li>
                            <li>
                                Does the ship's Procedures and Arrangements
                                Manual require a prewash subsequent disposal to
                                reception facilities?
                            </li>
                            <li>
                                Failure of pumping and/or stripping system:
                                <ol className="list-decimal pl-6">
                                    <li>time and nature of failure;</li>
                                    <li>reasons for failure;</li>
                                    <li>
                                        time when system has been made optional.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (D) MANDATORY PREWASH IN ACCORDANCE WITH THE SHIP'S
                            PROCEDURES AND ARRANGEMENTS MANUAL
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>
                                Identify tank(s), substance(s) and
                                category(ies).
                            </li>
                            <li>
                                Washing method:
                                <ol className="list-decimal pl-6">
                                    <li>
                                        Number of cleaning machines per tank;
                                    </li>
                                    <li>duration of wash/washing cycles;</li>
                                    <li>hot/cold wash.</li>
                                </ol>
                            </li>
                            <li>
                                Pre wash slops transferred to:
                                <ol className="list-decimal pl-6">
                                    <li>
                                        reception facility in unloading port
                                        (identify port)*;
                                    </li>
                                    <li>
                                        reception facility otherwise (identify
                                        port)*;
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                </section>
            </div>
            {/* Seventh Page */}
            <div className="px-8 py-4 mt-4 newpage">
                <section className="mb-8">
                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (E) CLEANING OF CARGO TANKS EXCEPT MANDATORY PREWASH
                            OTHERS PREWASH OPERATIONS, FINAL WASH, VENTILATION,
                            ETC.
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>
                                State time, identity tank(s), substance(s) and
                                category(ies) and state:
                                <ol className="list-decimal pl-6">
                                    <li>washing procedure used;</li>
                                    <li>
                                        cleaning agent(s) (identify agent(s) and
                                        quantities);
                                    </li>
                                    <li>
                                        ventilation procedure used (state number
                                        of fans used, duration of ventilation).
                                    </li>
                                </ol>
                            </li>
                            <li>
                                Tanks washing transferred:
                                <ol className="list-decimal pl-6">
                                    <li>into the sea;</li>
                                    <li>
                                        reception facility (identify port)*;
                                    </li>
                                    <li>
                                        to slops collecting tank (identify
                                        tank).
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (F) DISCHARGE INTO THE SEA OF TANK WASHINGS
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>
                                Identity of tank(s):
                                <ol className="list-decimal pl-6">
                                    <li>
                                        Were tank washing discharge during
                                        cleaning of tank(s)? If so, at what
                                        rate?
                                    </li>
                                    <li>
                                        Were tank washing(s) discharged from a
                                        slops collecting tank? If so, state
                                        quantity and rate of discharge.
                                    </li>
                                </ol>
                            </li>
                            <li>Time pumping commenced and stopped.</li>
                            <li>Ship's speed during discharge.</li>
                        </ol>
                    </div>

                    <div className="mb-26">
                        <h3 className="text-lg font-bold mb-2">
                            (G) BALLASTING OF CARGO TANKS
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Identity of tank(s) ballasted.</li>
                            <li>Time at start of ballasting.</li>
                        </ol>
                    </div>

                    <p className="text-sm italic mt-4">
                        Ships masters should obtain from the operator of the
                        reception facilities, which include barges and tank
                        trucks a receipt or certificate specifying the quantity
                        of tank washings transferred together with the time and
                        date of transfer. The receipt or certificate should be
                        kept together with the Cargo Record Book.
                    </p>
                </section>
            </div>
            {/* Eigth Page */}
            <div className="px-8 py-4 mt-4 newpage">
                <section className="mb-8">
                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (H) DISCHARGE OF BALLAST WATER FROM CARGO TANKS
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Identity of tank(s).</li>
                            <li>
                                Discharge of ballast:
                                <ol className="list-decimal pl-6">
                                    <li>into the sea;</li>
                                    <li>
                                        to reception facilities (identify
                                        port)*.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                Time ballast discharge commenced and stopped.
                            </li>
                            <li>Ship's speed during discharge.</li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (I) ACCIDENTAL OR OTHER EXCEPTIONAL DISCHARGE
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Time of occurrence.</li>
                            <li>
                                Approximate quantity, substance(s) and
                                category(ies)
                            </li>
                            <li>
                                Circumstances of discharge or escape and general
                                remarks.
                            </li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (J) CONTROL BY AUTHORIZED SURVEYORS
                        </h3>
                        <ol className="list-decimal pl-6 space-y-1">
                            <li>Identify port.</li>
                            <li>
                                Identity tank(s), substance(s), category(ies)
                                discharged ashore.
                            </li>
                            <li>
                                Have tank(s), pump(s), and piping system(s) been
                                emptied?
                            </li>
                            <li>
                                Has a prewash in accordance with the ship's
                                Procedures and Arrangements Manual been carried
                                out?
                            </li>
                            <li>
                                Have tank washings resulting from the prewash
                                been discharged ashore and is the tank empty?
                            </li>
                            <li>
                                An exemption has been granted from mandatory
                                prewash.
                            </li>
                            <li>Reasons for exemption.</li>
                            <li>Name and signature of authorized surveyor.</li>
                            <li>
                                Organization, company, government agency for
                                which surveyor works.
                            </li>
                        </ol>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-2">
                            (K) ADDITIONAL OPERATIONAL PROCEDURES AND REMARKS
                        </h3>
                    </div>

                    <p className="text-sm italic mt-4">
                        Ships masters should obtain from the operator of the
                        reception facilities, which include barges and tank
                        trucks a receipt or certificate specifying the quantity
                        of tank washings transferred together with the time and
                        date of transfer. The receipt or certificate should be
                        kept together with the Cargo Record Book.
                    </p>
                </section>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        dateRange,
        vesselName: vesselInfo.vesselName,
        imoNumber: vesselInfo.imoNumber,
        tonnage: vesselInfo.tonnage,
        distinctiveNumberOrLetters: vesselInfo?.distinctiveNumberOrLetters,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(CRBCoverPage);
